import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

const AuthRedirect = () => {
  const { user, userRole, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {    
    // Wait for auth to finish loading
    if (loading) return

    // If user is logged in, redirect based on role
    if (user) {
      // If userRole is still loading, wait a moment before fallback
      if (!userRole) {
        const timeoutId = setTimeout(() => {
          // If still no userRole after timeout, use superadmin as fallback
          const targetRoute = '/superadmin'
          navigate(targetRoute, { replace: true })
        }, 1000)
        return () => clearTimeout(timeoutId)
      } else {
        // UserRole is loaded, redirect to appropriate dashboard
        const targetRoute = userRole === 'superadmin' ? '/superadmin' : 
                           userRole === 'admin' ? '/admin' : 
                           userRole === 'customer' ? '/customer' : '/superadmin'
        navigate(targetRoute, { replace: true })
      }
    }
  }, [user, userRole, loading, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-pulse text-primary text-lg">Wird weitergeleitet...</div>
      </div>
    </div>
  )
}

export default AuthRedirect